var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"type":"flex","justify":_vm.align}},[_c('img',{style:(_vm.getStyle),attrs:{"src":_vm.imageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }